import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";



@Injectable({
  providedIn: "root",
})
export class DataShareService {

  teamsArrayDataShareService: any[] = [];
  allTeamsArrayDataShareService: any[] = [];
  driversArrayDataShareService: any[] = [];
  hubsArrayDataShareService: any[] = [];
  taskArrayDataShareService: any[] = [];
  adminArrayDataShareService: any[] = [];
  dispatcherArrayDataShareService: any[] = [];
  apiKeysArrayDataShareService: any[] = [];
  WebhookArrayDataShareService: any[] = [];
  vehicleBrandArrayDataShareService: any[] = [];
  vehicleModelArrayDataShareService: any[] = [];
  vehicleArrayDataShareService: any[] = [];
  carTypeArrayDataShareService: any[] = [];
  driverShiftArrayDataShareService: any[] = [];
  hubZoneArrayDataShareService: any[] = [];
  serviceZoneArrayDataShareService: any[] = [];
  branchArrayDataShareService: any[] = [];
  surgeZoneArrayDataShareService: any[] = [];
  areaZoneArrayDataShareService: any[] = [];
  planCreatedArrayDataShareService: any[] = [];
  planCreatedFromTaskArrayDataShareService: any[] = [];

  constructor() { }

  setTeamsFromListResponse(result: any): void {
    this.teamsArrayDataShareService = result?.status ? (result.data || []) : [];
    const allTeam = result?.allTeam ?? result?.allTeams;
    this.allTeamsArrayDataShareService =
      result?.status && Array.isArray(allTeam) ? allTeam : [];
  }

  private subject = new Subject<any>();

  shareData(data: any) {
    this.subject.next(data);
  }

  getData(): Observable<any> {
    return this.subject.asObservable();
  }
}

